import { Row, Col, Image, Spin } from "antd";
import React from "react";
import JobSummary from "./Components/JobSummary";
import JobHeader from "./Components/JobHeader";
import JobDetails from "./Components/JobDetails";
import JobLocation from "./Components/JobLocation";
import useIsSmallScreen from "../../../hooks/useIsSmallScreen";
import SimilarJobs from "./Components/SimilarJobs";
import usePersonnelAdvertService from "../../../services/usePersonnelAdvertService";
import { useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import JobBreadcrumb from "./Components/JobBreadcrumb";

const AdvertDetailPersonnel = () => {
  const isSmallScreen = useIsSmallScreen();
  const params = useParams();
  const advertId = params.advertId;
  const routerLocation = useLocation();
  const { useGetAdvertById } = usePersonnelAdvertService();
  const {
    data: advertDetails,
    isLoading,
    isError,
  } = useGetAdvertById(advertId);
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, 0);
  }, [advertId, routerLocation.pathname]);

  if (isLoading) {
    return (
      <div
        style={{
          padding: isSmallScreen ? 15 : 60,
          backgroundColor: "white",
          minHeight: "400px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        <Spin size="large" tip="İlan detayları yükleniyor..." />
      </div>
    );
  }

  const {
    firmUser: {
      firm: { companyName, imageUrl },
    },
    position: { name: positionName },
    sector: { name: sectorName },
    department: { name: departmentName },
    jobType: { description: jobType },
    durationType: { description: durationType },
    wageType: { description: wageType },
    wagePeriod: { description: wagePeriod },
    jobDescription,
    requiredQualification,
    personnelCount,
    startDate,
    endDate,
    minWage,
    maxWage,
    wage,
    minAge,
    maxAge,
    address,
    coordinate: { latitude: lat, longitude: long },
    currency,
    jobDuration,
    title,
    district,
    city,
    country,
    minEducationLevel,
    isExperienceRequired,
    experienceYear,
    keywords,
    options,
    isFavorite,
    isApplied,
    isAssigned,
    isCompleted,
    id,
    coverLetter,
  } = advertDetails?.data;

  const wageAmount = wage !== null ? wage : `${minWage}-${maxWage} `;

  const location =
    district !== null
      ? `${district.name} / ${district.city.name}`
      : city !== null
      ? city.name
      : country.name;

  const education =
    minEducationLevel !== null
      ? minEducationLevel.description
      : "Eğitim Tercihi Yok";

  const experience = isExperienceRequired
    ? `${experienceYear} Yıllık Deneyim`
    : "Deneyim Aranmıyor";

  const isApplicableToApply = !isApplied && !isAssigned && !isCompleted;

  return (
    <>
      <JobBreadcrumb title={title} />
      <div
        style={{
          padding: isSmallScreen ? "15px 0" : 15,
          backgroundColor: "white",
        }}>
        <Spin spinning={isLoading}>
          <Col>
            <Row gutter={[16, 16]}>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={18}
                style={{
                  textAlign: "center",
                  padding: isSmallScreen ? "0 15px" : "0 50px",
                }}>
                <div style={{ width: "100%", overflow: "hidden" }}>
                  <Image
                    src="https://images.pexels.com/photos/1595385/pexels-photo-1595385.jpeg?cs=srgb&dl=pexels-hillaryfox-1595385.jpg&fm=jpg"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    preview={false}
                  />
                </div>
                <JobHeader
                  imageUrl={imageUrl}
                  title={title}
                  companyName={companyName}
                  personnelCount={personnelCount}
                  durationType={durationType}
                  jobType={jobType}
                  location={location}
                  jobDuration={jobDuration}
                  sector={sectorName}
                  department={departmentName}
                  position={positionName}
                  coverLetter={coverLetter}
                />
                <JobDetails
                  requiredQualification={requiredQualification}
                  jobDescription={jobDescription}
                  keywords={keywords}
                  options={options}
                  address={address}
                  experience={experience}
                  wagePeriod={wagePeriod}
                  wageType={wageType}
                  minEducationLevel={education}
                  minAge={minAge}
                  maxAge={maxAge}
                  wageAmount={wageAmount}
                  currency={currency}
                />
              </Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={6}
                style={{
                  padding: "0 15px",
                }}>
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "8px",
                    padding: "20px",
                    marginBottom: "20px",
                  }}>
                  <JobSummary
                    imageUrl={imageUrl}
                    currency={currency}
                    education={education}
                    experience={experience}
                    location={location}
                    wageAmount={wageAmount}
                    wageType={wageType}
                    position={positionName}
                    sector={sectorName}
                    title={title}
                    isApplicableToApply={isApplicableToApply}
                    isFavorite={isFavorite}
                    advertId={id}
                    coverLetter={coverLetter}
                    isApplied={isApplied}
                  />
                </div>
                <JobLocation lat={lat} long={long} />
              </Col>
            </Row>
            <SimilarJobs advertId={id} headerText="Benzer İlanlar" />
          </Col>
        </Spin>
      </div>
    </>
  );
};

export default AdvertDetailPersonnel;
